export default "__VITE_ASSET__iHpcp6x6__"